<div class="card-stats">
  <span *ngIf="title" class="card-stats__title">{{ title }}</span>
  <div class="card-stats__strip">
    <div class="card-stats__tile" *ngFor="let item of items">
      <span class="card-stats__value">{{ item.value }}</span>
      <span class="card-stats__label">{{ item.label }}</span>
      <span
        *ngIf="item.delta"
        class="card-stats__delta"
        [ngClass]="trendClass(item.trend)"
        [attr.aria-label]="'Change: ' + item.delta">
        {{ trendArrow(item.trend) }}&thinsp;{{ item.delta }}
      </span>
    </div>
  </div>
</div>
